import { render, staticRenderFns } from "./skip.vue?vue&type=template&id=0d320c19&scoped=true"
import script from "./skip.vue?vue&type=script&lang=js"
export * from "./skip.vue?vue&type=script&lang=js"
import style0 from "./skip.vue?vue&type=style&index=0&id=0d320c19&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d320c19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d320c19')) {
      api.createRecord('0d320c19', component.options)
    } else {
      api.reload('0d320c19', component.options)
    }
    module.hot.accept("./skip.vue?vue&type=template&id=0d320c19&scoped=true", function () {
      api.rerender('0d320c19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/frame/page/login/skip.vue"
export default component.exports